
const dateUtil = require('../../dateUtil/dateUtil');
const saleCalculator = require('../sales/saleCalculator');


const storefrontTimingsCalculator = require('./storefrontTimingsCalculator');

module.exports.defaultPrepTime = 20;
module.exports.defaultDeliveryTime = 20;
module.exports.defaultOrderIntervals = [5,10,15];

module.exports.getSalePrepAndDeliveryTimings = function (sale, storefrontTimingConfigurations)
{
    const applicableTimingOverride = this.getStorefrontTimingOverride(sale, storefrontTimingConfigurations);

    return this.getPrepAndDeliveryTimings(storefrontTimingConfigurations, applicableTimingOverride);
}

module.exports.getStorefrontTimingOverride = function (sale, storefrontTimingConfigurations)
{
    const propertyNow = dateUtil.convertToLocalStandard(dateUtil.getNow())

    const timingOverrides = (storefrontTimingConfigurations != null) ? storefrontTimingConfigurations.overrides : [];
    const salePrice = saleCalculator.calculateTotalSalePrice(sale);
    const applicableTimingOverride = storefrontTimingsCalculator.calculateApplicableTimingOverride(salePrice, sale.dispatchType, propertyNow, timingOverrides);

    return applicableTimingOverride;
}


module.exports.getPrepAndDeliveryTimings = function (storefrontTimingConfigurations, applicableTimingOverride)
{
    let prepTime = this.defaultPrepTime;
    if (applicableTimingOverride && applicableTimingOverride.prepTime != null)
        prepTime = applicableTimingOverride.prepTime;
    else if (storefrontTimingConfigurations && storefrontTimingConfigurations.defaultPrepTime != null)
        prepTime = storefrontTimingConfigurations.defaultPrepTime;

    let deliveryTime = this.defaultDeliveryTime;
    if (applicableTimingOverride && applicableTimingOverride.deliveryTime != null)
        deliveryTime = applicableTimingOverride.deliveryTime;
    else if (storefrontTimingConfigurations && storefrontTimingConfigurations.defaultDeliveryTime != null)
        deliveryTime = storefrontTimingConfigurations.defaultDeliveryTime;

    const orderIntervals = storefrontTimingConfigurations.orderIntervals || this.defaultOrderIntervals;

    return { prepTime, deliveryTime, orderIntervals };
}

module.exports.adjustForOrderInterval = function (dateTime, orderInterval)
{
    const minutes = Math.round(dateUtil.getMinutes(dateTime));

    let addMinutes = 0;

    if (orderInterval)
    {
        while (((minutes + addMinutes) % orderInterval) !== 0)
            addMinutes += 1;
    }

    return dateUtil.addMinutes(dateTime, addMinutes);
}